import { useState } from "react";
import styles from "./CreateFolder.module.css";
import * as Menu from "components/MenuPanel/MenuPanel";
import { Button } from "components/Button/Button";
import { IconChevronDown } from "components/Icons/IconChevronDown";
import { IconChevronUp } from "components/Icons/IconChevronUp";
import { SwatchButton, Swatches } from "components/Swatches/Swatches";
import { COLOR_OPTIONS, ICON_OPTIONS } from "./themeOptions";
import { ControlledClickPopover } from "components/ClickPopover";

export function SelectTheme({
  selectedColor,
  setSelectedColor,
  selectedIcon,
  setSelectedIcon,
}: {
  selectedColor: string;
  setSelectedColor: (color: string) => void;
  selectedIcon: string;
  setSelectedIcon: (icon: string) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.selectTheme}>
      <label>Theme</label>
      <ControlledClickPopover
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={() => (
          <Menu.Panel>
            <Menu.Section>
              <Swatches
                name="icon"
                value={selectedIcon}
                onChange={setSelectedIcon}
              >
                {ICON_OPTIONS.filter((icon) => icon.value !== "archive").map(
                  (option) => (
                    <SwatchButton key={option.value} value={option.value}>
                      <div
                        className={styles.iconOption}
                        style={{ color: `${selectedColor}` }}
                      >
                        {option.label}
                      </div>
                    </SwatchButton>
                  )
                )}
              </Swatches>
            </Menu.Section>
            <Menu.Section>
              <Swatches
                name="color"
                value={selectedColor}
                onChange={setSelectedColor}
              >
                {COLOR_OPTIONS.map((option) => (
                  <SwatchButton key={option.value} value={option.value}>
                    <div
                      className={styles.color}
                      style={{ backgroundColor: `${option.value}` }}
                    />
                  </SwatchButton>
                ))}
              </Swatches>
            </Menu.Section>
          </Menu.Panel>
        )}
        position="below-align-left"
      >
        <Button theme="tertiary" size="M">
          <div className={styles.selected}>
            <div
              className={styles.iconAndColor}
              style={{ color: `${selectedColor}` } as React.CSSProperties}
            >
              <div
                className={styles.selectedIcon}
                style={
                  {
                    backgroundColor: `${turnAccentColorToCanvasColor(
                      selectedColor
                    )}`,
                  } as React.CSSProperties
                }
              >
                {
                  ICON_OPTIONS.find((option) => option.value === selectedIcon)
                    ?.label
                }
              </div>
              <label>
                {
                  COLOR_OPTIONS.find((option) => option.value === selectedColor)
                    ?.displayName
                }
              </label>
            </div>
            {isOpen ? <IconChevronUp /> : <IconChevronDown />}
          </div>
        </Button>
      </ControlledClickPopover>
    </div>
  );
}

function turnAccentColorToCanvasColor(color: string) {
  return color.replace("var(--feedback--accent--", "var(--feedback--canvas--");
}
